<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            Setting ( This page has not been developed.)
          </CCardHeader>
        </CCard>
       
      </CCol>
    </CRow>
    
  </div>
</template>

<script>
export default {
  name: "Setting",
  data() {
    return {
     
    };
  },
};
</script>
